export default __webpack_public_path__ + "media/images/table_alias_dirty-cd29d84113561edea7c26437e0310bf7.png";